// @flow

import Cell from '@/lib/cell';
import Condition from '@/lib/condition';
import UnitTemplates from '@/lib/unit_templates';

export default class {
  static process(cell: Cell) {
    UnitTemplates.forEach(template => {
      this.spawnByUnitTemplate(cell, template);
    });
  }

  static spawnByUnitTemplate(cell: Cell, unit: UnitTemplate) {
    let probability = 1;
    if (!unit.spawn) return;
    const { spawn } = unit;

    // 水中にユニットは出現しない
    if (cell.elevation < 0) return;

    spawn.conditions.forEach(condition => {
      const value = cell.getParameter(condition[0], condition[1]);
      const c = new Condition(condition[2]);

      if (c.hasCalculate()) {
        probability *= Math.min(1, c.calculate(value));
      }
    });

    if (Math.random() * 100 < probability * 100 * spawn.rate) {
      // let age = 0;
      // if (spawn.age) {
      //   age = Math.round(this.rnorm() * spawn.age.sigma + spawn.age.average);
      //   if (age < 0) age = 0;
      // }

      cell.addUnit(unit);
    }
  }

  static rnorm(): number {
    // 平均0、標準偏差1の正規乱数を返す
    return (
      Math.sqrt(-2 * Math.log(1 - Math.random())) *
      Math.cos(2 * Math.PI * Math.random())
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/cell_event/spawn_event.js